/**
 * Created by piotr.pozniak@thebeaverhead.com on 16/05/2024
 */

import React, { useContext } from "react";
import PropTypes from "prop-types";
import WidgetSettingsContext from "../../../../contexts/WidgetSettingsContext";
import appConfig from "../../../../appConfig";
import { getUploadResourceUrl } from "../../../../helpers/url";
import Logo from "./Logo";
import BackButton from "./BackButton";
import classNames from "classnames";

/**
 *
 */
const isHostedPage = (widgetDomain) => {
  const hostedPages = [
    `my.${appConfig.domain}`,
    `dev.${appConfig.domain}`,
    process.env.PUBLIC_WIDGET_HOST,
    `localhost`,
    widgetDomain,
  ];

  return hostedPages.includes(window.location.hostname);
};

const BrandingHeader = ({ calendar, embedded }) => {
  const orgSettings = calendar.model?.organization?.settings;

  const orgLogo = getUploadResourceUrl(orgSettings?.logo);

  const widgetSettings = useContext(WidgetSettingsContext);
  const showLogo = widgetSettings["brandShowLogo"];
  const showBackButton = widgetSettings["brandShowBackButton"];
  const backButtonLabel = widgetSettings["brandBackButtonLabel"];
  const backButtonUrl = widgetSettings["brandBackButtonURL"];
  const headerControlsDirection = widgetSettings["brandLogoPosition"];
  const isHeaderSticky = widgetSettings["brandLogoSticky"]

  if (!embedded || !orgLogo || !isHostedPage(calendar.model?.widget_domain)) {
    return null;
  }

  if (!showLogo && !showBackButton) {
    return null;
  }

  let positionControlClass = headerControlsDirection;

  if (headerControlsDirection === "rev-logo-last") {
    if (!showBackButton) {
      positionControlClass = "dc-calendar-branding--header_end";
    }
  } else {
    if (!showLogo) {
      positionControlClass = "dc-calendar-branding--header_end";
    }
  }

  return (
    <div
      className={classNames(
        "dc-calendar-branding--header",
        headerControlsDirection,
        positionControlClass,
        {
          "dc-calendar-branding--header_sticky": isHeaderSticky
        }
      )}
    >
      <Logo show={showLogo} widget={calendar} />
      <BackButton
        show={showBackButton}
        label={backButtonLabel}
        url={backButtonUrl}
      />
    </div>
  );
};

BrandingHeader.defaultProps = {};

BrandingHeader.propTypes = {
  calendar: PropTypes.object,
  embedded: PropTypes.bool,
};

export default BrandingHeader;
